


import axios from "axios";

const ipmaAPI = axios.create({
  baseURL: "https://api.ipma.pt/open-data",
});

export const getLastData = async () => {
  let result = await ipmaAPI.get('/observation/meteorology/stations/obs-surface.geojson');
  let fundao = result.data.features.find(item => item.properties.idEstacao === 1210698);
  console.log("--------------------------------- %o", fundao);
  return fundao;
}

export const getForecast = async () => {
  let result = await ipmaAPI.get('/forecast/meteorology/cities/daily/1050200.json');
  console.log("--------------------------------- %o", result.data);
  return result;
}
